import { FetchAPI } from './auth-service';

const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';

class SystemDataService {
    constructor () {
        // we only need one of these
        if (!SystemDataService.instance) {
            SystemDataService.instance = this;
        }
        this.searchPlaceholder = 'Search system';

        this.getSystemSettings = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/',
            });
        };

        this.updateSystemSettings = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/',
                body: data,
            });
        };

        this.checkElasticHost = (data) => {
            return FetchAPI({
                method: 'GET',
                url: 'system/-check-elastic-host',
                body: data
            });
        };

        this.checkLDAPConn = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'system/-check-ldap-conn',
                body: data
            });
        };

        this.checkMailHost = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'system/-check-mail-host',
                body: data
            });
        };

        this.checkURL = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'system/-check-url',
                body: data
            });
        };

        this.checkProxyURL = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'system/-check-proxy-url',
                body: data
            });
        };

        this.getConstants = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/-constants',
            });
        };

        this.getLDAPLogs = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/-ldap-logs',
            });
        };

        this.getStandby = () => {
            return FetchAPI({
                method: 'GET',
                url: `${MC2CHECK ? 'mc2/' : ''}system/-standby/`,
            });
        };

        // instead use:
        // import { UISettings } from 'auth-service';
        // UISettings.lookups
        // UISettings.messages

        // this.getUI = () => {
        //     return FetchAPI({
        //         method: 'GET',
        //         url: `system/-ui`,
        //     });
        // };

        this.awsConfigStatus = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/awsconfigstatus',
            });
        };

        this.awsCredAccess = () =>{
            return FetchAPI({
                method: 'GET',
                url: 'system/awssecretaccesskey'
            })
        }

        this.awsConfigVerify = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/awsconfigverify',
                body: data,
            });
        };

        this.addAuditRecord = (data) => {
            return FetchAPI({
                url:'system/audit',
                method:'POST',
                body: data,
            })
        }
        
        // different permissions require different endpoints
        this.exportsCertAttributes = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/exports/cert/attribs',
                body: data,
                plain: true,
            });
        };

        this.auditExportsCertAttributes = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/audit/cert/attribs',
                body: data,
                plain: true,
            });
        };

        this.ldapCertAttributes = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/ldap/cert/attribs',
                body: data,
                plain: true,
            });
        };

        this.logDump = (data) => {
            return FetchAPI({
                method: 'GET',
                url: 'system/logdump',
            });
        };

        this.mailLogs = (data) => {
            return FetchAPI({
                method: 'GET',
                url: 'system/mail-logs',
            });
        };

        this.getMIBFile = (filename) => {
            return FetchAPI({
                method: 'GET',
                url: `system/mib/${filename}`,
            });
        };

        this.getUserNotices = (data) => {
            return FetchAPI({
                method: 'GET',
                url: 'system/notices',
            });
        };

        this.sandboxURLVerify = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/sandbox_url_config/verify',
                body: data,
            });
        };

        this.getLicense = () => {
            return FetchAPI({
                method: 'GET',
                url: 'license/info',
            });
        };

        this.getLicenseSN = () => {
            return FetchAPI({
                method: 'GET',
                url: 'license/sn',
            });
        };

        this.updateLicense = (license) => {
            return FetchAPI({
                method: 'PUT',
                url: `license/key/${license}`,
            });
        };

        this.downloadMIB = (file) => {
            return FetchAPI({
                method: 'GET',
                url: `system/mib/${file}`,
            });
        };

        this.getWebSettings = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/web',
            });
        };

        this.uploadWebCerts = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'system/web',
                body: data,
            });
        };

        this.enableHSTS = () => {
            return FetchAPI({
                method: 'PUT',
                url: 'system/web/hsts',
            });
        };

        this.disableHSTS = () => {
            return FetchAPI({
                method: 'DELETE',
                url: 'system/web/hsts',
            });
        };

        return SystemDataService.instance;
    }
}

const SystemService = new SystemDataService();

export default SystemService;
